import {Root} from "./store-root";
import {action, observable} from "mobx";

export class ToasterStore {
    parent : Root;
    constructor(root:Root) {
        this.parent = root;
    }

    @observable.shallow toaster = {
        open: false,
        body: null
    }

    @action opentoaster = (content: any) => {
        this.toaster.open = true;
        this.toaster.body = content;
    }

    @action closetoaster = () => {
        this.toaster.open = false;
        this.toaster.body = null;
    }
}
